import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-y-1" }

import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { getFormInput } from '@/utils/form-input-helper';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileHeader',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FormStepInputs, {
      step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_unref(getFormInput)(props.content, 'title'))), null, 16)
        ])
      ]),
      _: 1
    }, 8, ["step"])
  ]))
}
}

})